import React from "react";
import cn from "classnames";

const Message = ({ visible, content }) => {
  return (
    <div className={cn("message", {visible: visible})}>
      <svg width="16px" height="16px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.0185378,16.0002802 L31.9875103,2.03894584 L29.9813969,0.000345421604 L16,13.9817423 L2.01860308,0.000345421604 L0.012489713,2.03894584 L13.9814622,16.0002802 L-0.00375381455,29.9854962 L2.01040741,31.9996574 L16,18.0177142 L29.9895926,31.9996574 L32.0037538,29.9854962 L18.0185378,16.0002802 Z"></path>
      </svg>
      {content}
    </div>
  );
};

export default Message;
